import { Box, Container, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Screens1 from '../../assets/images/screens-1.webp';
import Scribble1 from '../../assets/images/scribble-1.svg';
import AppleTvIcon from '../../assets/icons/icon-apple-tv.svg';
import AndroidTvIcon from '../../assets/icons/icon-android.svg';
import AppleIcon from '../../assets/icons/icon-apple.svg';
import FireTvIcon from '../../assets/icons/icon-fire-tv.svg';
import LaptopIcon from '../../assets/icons/icon-laptop.svg';
import MagIcon from '../../assets/icons/icon-mag.svg';
import SmartTvIcon from '../../assets/icons/icon-smart-tv.svg';
import SlexLogoIcon from '../../assets/icons/slex-logo-icon.svg';
import { StyledButton } from '../../components/Utils/UIUtils';

export default function Hero() {
  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: 'primary.neutral1000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: { xs: 'auto', md: '100%' },
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 4,
          backgroundImage: `url(${SlexLogoIcon})`,
          backgroundSize: '60% 60%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          pb: { xs: 3, sm: 4, md: 5 },
          height: '100%',
        }}
        maxWidth="md"
      >
        <img
          src={Screens1}
          alt="Slex Screens"
          style={{
            width: '100%',
            height: '300px',
            objectFit: 'contain',
          }}
          loading="eager"
        />
        <Stack gap={3} component={'header'}>
          <Typography
            variant="h1"
            sx={{
              color: 'text.white',
              fontSize: { xs: '32px', md: '40px' },
              fontWeight: '600',
              zIndex: 90,
            }}
          >
            {t('HOME_PAGE.HERO.TITLE_PART1')}{' '}
            <span
              style={{ position: 'relative', lineHeight: '150%', zIndex: 90 }}
            >
              {t('HOME_PAGE.HERO.TITLE_PART2')}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '40px', md: '56px' },
                  right: '0px',
                  display: 'flex',
                }}
              >
                <img
                  src={Scribble1}
                  alt="Scribble"
                  style={{
                    zIndex: 99,
                    maxWidth: '100%',
                    minWidth: '256px',
                  }}
                  loading="eager"
                />
              </Box>
            </span>
          </Typography>
          <Typography variant="body1" sx={{ color: 'primary.neutral550' }}>
            {t('HOME_PAGE.HERO.DESCRIPTION')}
          </Typography>
        </Stack>
        <Stack gap={2} justifyContent={'center'} alignItems={'center'}>
          <Stack
            direction={'row'}
            gap={2}
            flexWrap={'wrap'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <StyledButton
              href="/pricing"
              variant="contained"
              color="primary"
              size="large"
              sx={{
                p: '12px 24px',
                border: '1px solid',
                borderColor: 'primary.main',
                borderRadius: theme.shape.defaultBorderRadius,
                fontSize: { xs: '13px', md: '15px' },
                fontWeight: '400',
              }}
            >
              {t('HOME_PAGE.HERO.BUTTON1')}
            </StyledButton>
            <StyledButton
              href="/free-trial"
              variant="outlined"
              color="primary"
              size="large"
              sx={{
                p: '12px 24px',
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: 'primary.neutral300',
                borderRadius: theme.shape.defaultBorderRadius,
                color: 'primary.neutral300',
                fontSize: { xs: '13px', md: '15px' },
                fontWeight: '400',
                '&:hover': {
                  bgcolor: 'primary.white',
                  borderColor: 'primary.white',
                  color: 'primary.neutral1000',
                },
              }}
            >
              {t('HOME_PAGE.HERO.BUTTON2')}
            </StyledButton>
          </Stack>
          <Typography
            variant="body1"
            sx={{ fontSize: '14px', color: 'primary.neutral550' }}
          >
            {t('HOME_PAGE.HERO.NO_CREDIT_CARD')}
          </Typography>
        </Stack>
        <Stack direction="column" gap={2}>
          <Typography
            variant="body1"
            sx={{ color: 'primary.neutral550', fontSize: '18px' }}
          >
            {t('HOME_PAGE.HERO.AVAILABLE_ON')}
          </Typography>
          <Stack
            sx={{
              display: 'flex',
              gap: 4,
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <Box
              sx={{
                width: '32px',
                height: '32px',
                backgroundImage: `url(${AppleTvIcon})`,
                backgroundSize: '32px 32px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '26px',
                height: '40px',
                backgroundImage: `url(${AppleIcon})`,
                backgroundSize: '26px 40px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '34px',
                height: '34px',
                backgroundImage: `url(${AndroidTvIcon})`,
                backgroundSize: '34px 34px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '50px',
                height: '34px',
                backgroundImage: `url(${LaptopIcon})`,
                backgroundSize: '50px 34px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '37px',
                height: '37px',
                backgroundImage: `url(${SmartTvIcon})`,
                backgroundSize: '37px 37px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '60px',
                height: '32px',
                backgroundImage: `url(${FireTvIcon})`,
                backgroundSize: '60px 32px',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Box
              sx={{
                width: '70px',
                height: '42px',
                backgroundImage: `url(${MagIcon})`,
                backgroundSize: '70px 42px',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
